import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { LocalService} from '../services/local.service';

@Injectable({
  providedIn: 'root'
})
export class SettingService {

  httpHeaderOptions: any;
  constructor(
    private http: HttpClient,
    private localService: LocalService
  ) {
    this.httpHeaderOptions = {
      headers: new HttpHeaders({
        'Authorization': 'Token ' + this.localService.getJsonValue('loggedinToken')
      })
    }
  }


  getProperDate(date) {    
    date = new Date(date.year, date.month - 1, date.day);
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date;
  }

  getOwlProperDate(date) {
    console.log(date)
    date = new Date(date)
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    return date;
  }
  
  getNgbDate(date) {
    var objDate = new Date(date);
    return {
      year: objDate.getFullYear(),
      month: objDate.getMonth() + 1,
      day: objDate.getDate()
    };
  }

  getOwlDate(date) {
    var objDate = new Date(date);
    // console.log(objDate)
    return {
      year: objDate.getFullYear(),
      month: objDate.getMonth(),
      day: objDate.getDate()
    };
  }

  getProperDateOnly(date) {
    date = new Date(date);
    date.setMinutes(date.getMinutes() - date.getTimezoneOffset());
    date = new Date(date); //Using this we can convert any date format to JS Date
    var mm = date.getMonth() + 1; // getMonth() is zero-based
    var dd = date.getDate();
    if (mm < 10) {
      mm = "0" + mm;
    }
    if (dd < 10) {
      dd = "0" + dd;
    }
    return [date.getFullYear(), mm, dd].join('-'); // padding
  };


  getAllStateList(): Observable<any> {
    return this.http.get(environment.apiEndpoint + 'all_states_list_add/', this.httpHeaderOptions)
  }

  getIntercomFloor(param) {
    return this.http.get(environment.apiEndpoint + 'hrms/locationwisefloor/list/?'+param, this.httpHeaderOptions);
  }

  getIntercomList(param){
    return this.http.get(environment.apiEndpoint + 'hrms/intercom/list/?'+param, this.httpHeaderOptions);
  }
}
